import React, { useContext } from "react";
import { Td, Tr } from "@chakra-ui/react";
import MenuForm from "components/Menu/MenuForm";
import { NavLink, useNavigate } from "react-router-dom";
import FormCrudCRUDContext from "context/FormCrudContex";

const TBodyFormEntryExpired = ({ data }) => {
  return (
    <Tr>
      <Td className="text-center">
        <NavLink
          target="_blank"
          to={`/FormShow?FormEntry=${data?.entryForm_id}`}
          className="ms-2"
        >
          <span className="formNumber">{data?.code_entryForm}</span>
        </NavLink>
      </Td>
      <Td className="text-center">{data?.name_qualified}</Td>
      <Td className="text-center">{data?.code_operation}</Td>
      <Td className="text-center">{data?.num_commercial_invoice}</Td>
      <Td className="text-center">{data?.num_transport_document}</Td>
      <Td className="text-center">{data?.status_entryForm}</Td>
      <Td className="text-center">
        <MenuForm data={data} />
      </Td>
    </Tr>
  );
};
export default TBodyFormEntryExpired
